import { isBedbankAccommodationItemView, isLEHotelAccommodationItemView } from 'lib/checkout/checkoutUtils'
import { isHotelPackage } from 'lib/offer/offerTypes'
import { findPropertyRateLoyaltyBasePackage, getPropertyRatePricingItemTotals, isPropertyRateLoyaltyPackageUpgradeItem } from './propertyRateLoyaltyUpgrade'

function getPackageTotals(pkg: App.HotelPackage): App.Checkout.ItemViewTotals {
  return {
    price: pkg.price,
    memberPrice: pkg.memberPrice,
    value: pkg.value,
    memberValue: pkg.memberValue,
    surcharge: 0,
    extraGuestSurcharge: 0,
    taxesAndFees: pkg.taxesAndFees,
    otherFees: {
      propertyFees: pkg.propertyFees,
    },
  }
}

function getItemViewAppliedLoyaltyUpgrade(itemView: App.Checkout.AnyItemView): App.Checkout.AccommodationItemViewLoyaltyAppliedUpgrade | undefined {
  // Bedbank targets have no `App.HotelPackage`, so the descriptor is precomputed in `getBedbankItemView`.
  if (isBedbankAccommodationItemView(itemView)) {
    return itemView.item.loyaltyAppliedUpgradeType ? itemView.appliedPropertyRateUpgrade : undefined
  }

  if (!isLEHotelAccommodationItemView(itemView) || !itemView.item.loyaltyAppliedUpgradeType) return

  if (isPropertyRateLoyaltyPackageUpgradeItem(itemView.item) && itemView.offer && itemView.pkg) {
    const originPackage = findPropertyRateLoyaltyBasePackage(itemView.offer, itemView.item)
    if (!originPackage || !isHotelPackage(itemView.pkg)) return

    // Target price comes from the `targetPricing` snapshot, not `pkg.price`/`memberPrice` — those are 0 for
    // dynamic LPC packages (resolved per-date), which would make the saving negative.
    const targetPricing = itemView.item.loyaltyPropertyRateUpgrade?.targetPricing
    const targetTotals = targetPricing ? getPropertyRatePricingItemTotals(targetPricing) : getPackageTotals(itemView.pkg)

    return {
      upgradeType: 'package',
      originPackage,
      originTotals: itemView.totals,
      originPrimaryTitle: itemView.item.loyaltyPropertyRateUpgrade?.sourceName || originPackage.name,
      targetPackage: itemView.pkg,
      targetTotals,
      targetPrimaryTitle: itemView.propertyRateName || itemView.pkg.name,
      targetImage: itemView.image,
      targetValue: targetTotals.value,
      targetInclusions: itemView.inclusions,
    }
  }

  if (itemView.loyaltyUpgradeAvailability) {
    const upgradeType = itemView.item.loyaltyAppliedUpgradeType
    const upgradeAvailability = itemView.loyaltyUpgradeAvailability

    if (upgradeType === 'room' &&
      (upgradeAvailability.upgradeAvailabilityType === 'room-only' || upgradeAvailability.upgradeAvailabilityType === 'room-and-package')) {
      return {
        upgradeType,
        originPackage: upgradeAvailability.originPackage,
        originTotals: upgradeAvailability.originTotals,
        originPrimaryTitle: upgradeAvailability.originPrimaryTitle,
        targetPackage: upgradeAvailability.roomUpgradePackage,
        targetTotals: upgradeAvailability.roomUpgradeTotals,
        targetPrimaryTitle: upgradeAvailability.roomUpgradePrimaryTitle,
      }
    }

    if (upgradeType === 'package' &&
      (upgradeAvailability.upgradeAvailabilityType === 'package-only' || upgradeAvailability.upgradeAvailabilityType === 'room-and-package')) {
      return {
        upgradeType,
        originPackage: upgradeAvailability.originPackage,
        originTotals: upgradeAvailability.originTotals,
        originPrimaryTitle: upgradeAvailability.originPrimaryTitle,
        targetPackage: upgradeAvailability.packageUpgradePackage,
        targetTotals: upgradeAvailability.packageUpgradeTotals,
        targetPrimaryTitle: upgradeAvailability.packageUpgradePrimaryTitle,
      }
    }
  }
}

export default getItemViewAppliedLoyaltyUpgrade
